import { useEffect, useState } from "react";
import { Button, Form, Row, message } from "antd";

const AddEditForm = ({
  form,
  editData,
  onSubmit,
  fields,
  onSuccess,
  successMessages = {
    create: "Created successfully",
    update: "Updated successfully",
  },
}) => {
  const isEdit = Boolean(editData);

  const [loading, setLoading] = useState(false);

  const handleFinish = async (values) => {
    setLoading(true);
    try {
      await onSubmit(values, editData);
      message.success(isEdit ? successMessages.update : successMessages.create);
      onSuccess?.();
      form.resetFields();
    } catch (error) {
      if (error?.data?.message) {
        message.error(error?.data?.message);
      }
    } finally {
      setLoading(false);
    }
  };

  // Populate form on edit
  useEffect(() => {
    if (!editData) return;
    form.setFieldsValue(editData);
  }, [editData, form]);

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      id="antdformstyle"
    >
      {fields}

      <Row className="modalFooter">
        <div className="modalBtns">
          <Button htmlType="reset" className="defaultBtn defaultGreyBtn">
            Clear
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            className="defaultBtn"
            loading={loading}
          >
            {isEdit ? "Update" : "Submit"}
          </Button>
        </div>
      </Row>
    </Form>
  );
};

export default AddEditForm;
